import Pruning, {PruningProps} from './Pruning';

export type {PruningProps};
export default Pruning;
